import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddSFBasicDetailsTab({
  sfdetails,
  SetSfDetails,
  roleId,
}) {
  const navigate = useNavigate();
  const getCompanyType = [
    { value: "Individual", label: "Individual" },
    { value: "Proprietorship Firm", label: "Proprietorship Firm" },
    { value: "Partnership Firm", label: "Partnership Firm" },
    { value: "Private Ltd Company", label: "Private Ltd Company" },
    { value: "Public Ltd Company", label: "Public Ltd Company" },
  ];

  const getnon_working_days = [
    { value: "0", label: "All Working Days" },
    { value: "1", label: "Sunday" },
    { value: "2", label: "Monday" },
    { value: "3", label: "Tuesday" },
    { value: "4", label: "Wednesday" },
    { value: "5", label: "Thrusday" },
    { value: "6", label: "Friday" },
    { value: "7", label: "Saturday" },
  ];

  const fdata = {
    id: sfdetails.id,
    display_name: sfdetails.display_name,
    company_name: sfdetails.company_name,
    address: sfdetails.address,
    pincode: sfdetails.pincode,
    state_id: sfdetails.state_id,
    city: sfdetails.city,
    company_type: sfdetails.company_type,
    non_working_days: sfdetails.non_working_days,
    rm_id: sfdetails.rm_id,
    asm_id: sfdetails.asm_id,
  };

  const [cityOption, setCityOption] = useState([]);
  const [cityValue, setCityValue] = useState(fdata.city);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState(fdata);
  const [rmOption, setRMOption] = useState([]);
  const [rmValue, setRMValue] = useState(fdata.rm_id);
  const [asmOption, setASMOption] = useState([]);
  const [asmValue, setASMValue] = useState(fdata.asm_id);
  const [ctypeValue, setCtypeValue] = useState(
    getCompanyType.find((x) => x.value === sfdetails.company_type),
  );

  const [nonWValue, setNonWValue] = useState(
    getnon_working_days.find((x) => x.value === sfdetails.non_working_days),
  );

  const getAllCity = async (pincode, callback) => {
    setCityOption([]);
    setCityValue(null);

    const listdata = await httpRequest(
      `getAllCity?pincode=${pincode}`,
      {},
      "GET",
    );

    if (listdata.status === true && listdata.message) {
      setCityOption(listdata.message);
      setFormData((prevFormData) => ({
        ...prevFormData,
        state_id: listdata.message[0].state.id,
        pincode,
      }));

      if (sfdetails.city) {
        const c = listdata.message.find(
          (option) => option.label === sfdetails.city,
        );
        setCityValue(c);
      }

      // Execute the callback after updating city options
      if (callback) {
        callback();
      }
    }
  };

  useEffect(() => {
    (async () => {
      if (sfdetails.pincode) {
        getAllCity(sfdetails.pincode);
      }

      const rmData = await httpRequest(
        "getrm-asm-list",
        { role: "Regional Manager" },
        "POST",
      );
      if (rmData.status === true && rmData.data) {
        setRMOption(rmData.data);
        setRMValue(rmData.data.find((x) => x.value === sfdetails.rm_id));
      }

      const asmData = await httpRequest(
        "getrm-asm-list",
        { role: "Area Service Manager" },
        "POST",
      );
      if (asmData.status === true && asmData.data) {
        setASMOption(asmData.data);
        setASMValue(asmData.data.find((x) => x.value === sfdetails.asm_id));
      }
    })();

    //eslint-disable-next-line
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();

    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.display_name) {
      errors.display_name = "Display Name is Required";
    }

    if (!value.company_name) {
      errors.company_name = "Company Name is Required";
    }
    if (!value.company_type) {
      errors.company_type = "Company Type is Required";
    }
    if (!value.pincode) {
      errors.pincode = "Pincode is Required";
    }

    if (!value.state_id) {
      errors.state_id = "State is Required";
    }

    if (!value.city) {
      errors.city = "City is Required";
    }
    if (!value.address) {
      errors.address = "Address is Required";
    }
    if (!value.non_working_days) {
      errors.non_working_days = "Non Working Day is Required";
    }

    if (!value.rm_id) {
      errors.rm_id = "RM Name is Required";
    }

    //console.log(errors);
    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "addupdatebasicdetails",
          formData,
          "POST",
        );
        setSubmit(false);

        if (data.status === true && data.message) {
          toast.success(data.message);
          if (!formData.id) {
            navigate(`/updateservicecenter/${data.data.id}`);
          } else {
            SetSfDetails(data.data);
          }
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  return (
    <>
      {/* Main content */}
      <section className="content sf-basic-details-section-wrap">
        <div className="container-fluid">
          <form
            id="addbasicdetails"
            onSubmit={onSubmitHandler}
            className="company-basic-form sf-basic-details-form"
          >
            <div className="form-section">
              <div className="section-header">
                <h5>Company</h5>
                <div className="section-divider"></div>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    Display Name <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.display_name ? "input-error" : ""}`}
                    name="display_name"
                    defaultValue={sfdetails.display_name}
                    placeholder="Enter Display Name"
                    id="display_name"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        display_name: e.target.value,
                      });
                    }}
                  />
                  {formErrors.display_name && (
                    <span className="error-message">
                      {formErrors.display_name}
                    </span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Company Name <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.company_name ? "input-error" : ""}`}
                    name="company_name"
                    defaultValue={sfdetails.company_name}
                    placeholder="Enter Company Name"
                    id="company_name"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        company_name: e.target.value,
                      });
                    }}
                  />
                  {formErrors.company_name && (
                    <span className="error-message">
                      {formErrors.company_name}
                    </span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Company Type <span className="required-mark">*</span>
                  </label>
                  <div className="select2-purple">
                    <Select
                      name="company_type"
                      value={ctypeValue}
                      options={getCompanyType}
                      placeholder="Select Company Type"
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          company_type: val.value,
                        });
                        setCtypeValue(val);
                      }}
                    />
                  </div>
                  {formErrors.company_type && (
                    <span className="error-message">
                      {formErrors.company_type}
                    </span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Non Working Day <span className="required-mark">*</span>
                  </label>
                  <div className="select2-purple">
                    <Select
                      name="non_working_days"
                      value={nonWValue}
                      options={getnon_working_days}
                      placeholder="Select Non Working Day"
                      onChange={(val) => {
                        setFormData({
                          ...formData,
                          non_working_days: val.value,
                        });
                        setNonWValue(val);
                      }}
                    />
                  </div>
                  {formErrors.non_working_days && (
                    <span className="error-message">
                      {formErrors.non_working_days}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="section-header">
                <h5>Location</h5>
                <div className="section-divider"></div>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    Address <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.address ? "input-error" : ""}`}
                    name="address"
                    defaultValue={sfdetails.address}
                    placeholder="Enter Company Address"
                    id="address"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        address: e.target.value,
                      });
                    }}
                  />
                  {formErrors.address && (
                    <span className="error-message">{formErrors.address}</span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Pincode <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.pincode ? "input-error" : ""}`}
                    maxLength="6"
                    name="pincode"
                    defaultValue={sfdetails.pincode}
                    placeholder="Enter Pincode"
                    id="pincode"
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        pincode: value,
                      });

                      if (value.length === 6) {
                        getAllCity(value);
                      }
                    }}
                  />
                  {formErrors.pincode && (
                    <span className="error-message">{formErrors.pincode}</span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    City <span className="required-mark">*</span>
                  </label>
                  <div className="select2-purple">
                    <Select
                      name="city"
                      placeholder="Select City"
                      value={cityValue}
                      options={cityOption}
                      onChange={(val) => {
                        setFormData({ ...formData, city: val.value });
                        setCityValue(val);
                      }}
                    />
                  </div>
                  {formErrors.city && (
                    <span className="error-message">{formErrors.city}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="section-header">
                <h5>RM & ASM Details</h5>
                <div className="section-divider"></div>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    RM Name <span className="required-mark">*</span>
                  </label>
                  <div className="select2-purple">
                    <Select
                      name="rm_id"
                      value={rmValue}
                      options={rmOption}
                      placeholder="Select RM"
                      onChange={(val) => {
                        setRMOption(val);
                        setFormData({ ...formData, rm_id: val.value });
                      }}
                    />
                  </div>
                  {formErrors.rm_id && (
                    <span className="error-message">{formErrors.rm_id}</span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">ASM Name</label>
                  <div className="select2-purple">
                    <Select
                      name="asm_id"
                      placeholder="Select ASM"
                      value={asmValue}
                      options={asmOption}
                      onChange={(val) => {
                        setFormData({ ...formData, asm_id: val.value });
                        setASMOption(val);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {roleId === 1 && (
              <div className="form-actions">
                <button type="submit" className="btn-submit">
                  <i className="fas fa-save"></i> Submit
                </button>
              </div>
            )}
          </form>
        </div>
        {/* /.container-fluid */}
      </section>
      {/* /.content */}
    </>
  );
}
